import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Router = () => {
  let location = useLocation();
  const query = new URLSearchParams(location.search);
  const navigate = useNavigate();

  console.log(query.get("token"), location);

  React.useEffect(() => {
    let token, empId, branchName, roleId;
    if (query.get("search")) {
      token = query.get("search");
    }
    if (query.get("empId")) {
      empId = query.get("empId");
    }
    if (query.get("branch")) {
      branchName = query.get("branch");
    }
    if (query.get("roleId")) {
      roleId = query.get("roleId");
    }

    localStorage.setItem("token", token);
    localStorage.setItem("empId", empId);
    localStorage.setItem("branchName", branchName);
    localStorage.setItem("roleId", roleId);
    
    token && navigate(`/cwc-support/dashboard`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
};

export default Router;
